import { z } from 'zod';

// ══════════════════════════════════════════
// User-scoped integration schemas
// (CUSTOMER + ADMIN can use these)
// ══════════════════════════════════════════

export const SaveIntegrationBodySchema = z.object({
  provider: z.string().min(1).max(50),
  credentials: z.record(z.string().min(1).max(5000)),
}).strict();

export const ValidateIntegrationBodySchema = z.object({
  provider: z.string().min(1).max(50),
  credentials: z.record(z.string().min(1).max(5000)),
}).strict();

// ══════════════════════════════════════════
// Runner-only: resolve token for execution
// ══════════════════════════════════════════

export const ResolveIntegrationSchema = z.object({
  customer_id: z.string().uuid(),
  provider: z.string().min(1).max(50),
  key_name: z.string().min(1).max(100),
}).strict();

// ══════════════════════════════════════════
// Types
// ══════════════════════════════════════════

export type SaveIntegrationBody = z.infer<typeof SaveIntegrationBodySchema>;
export type ValidateIntegrationBody = z.infer<typeof ValidateIntegrationBodySchema>;
export type ResolveIntegrationInput = z.infer<typeof ResolveIntegrationSchema>;
